<template>
  <div class="fit">
    <q-card class="column fit">
      <googleMaps
        :center="{ lng: 172.64715, lat: -43.5781 }"
        :zoom="7"
        mapType="terrain"
        :clustorMarkers="markers"
        :options="{
          zoomControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: true,
        }"
        style="height: 100%; width: 100%; position: relative; z-index: 1"
        @updatePos="updateCenterPOS"
        @clustorMapMarkerClicked="loadReport"
        ref="gmap"
        @showMarkers="showSurveys"
      >
      </googleMaps>
    </q-card>
    <q-dialog v-model="showSurveyList" max-width="600px">
      <q-card v-if="showSurveyList" tile style="width: 90vw; max-width: 600px">
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div
              style="display: inline-block; font-family: 'Outfit', cursive"
              class="text-h6"
            >
              Select a Survey
            </div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="showSurveyList = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="row">
            <div
              v-for="(survey, index) in selectedSuveys"
              :key="`survey_${index}`"
              class="col-12 q-pa-xs"
            >
              <q-card>
                <q-card-section>
                  <h6 class="q-my-none">
                    {{ survey.name }}
                  </h6>
                </q-card-section>
                <q-card-section>
                  <div class="row">
                    <div class="col-12">
                      <span style="font-weight: bold">Upper Limit:</span>
                      {{
                        survey.recordedUpperLimit
                          ? survey.recordedUpperLimit
                          : survey.upperLimit
                      }}
                    </div>
                    <div class="col-12">
                      <span style="font-weight: bold">Lower Limit:</span>
                      {{
                        survey.recordedLowerLimit
                          ? survey.recordedLowerLimit
                          : survey.lowerLimit
                      }}
                    </div>
                    <div class="col-12">
                      <span style="font-weight: bold">Date:</span>
                      {{ formatDate(survey.date) }}
                    </div>
                    <div class="col-12">
                      <q-btn
                        flat
                        text
                        class="full-width"
                        @click="loadReport(survey)"
                        >View Report</q-btn
                      >
                    </div>
                  </div>
                </q-card-section>
              </q-card>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import googleMaps from "@/components/googleMaps/googleMaps.vue";
import moment from "moment";

export default {
  components: { googleMaps },
  computed: {
    ...mapGetters(["currentUser", "pastSurveys", "pastSurveysLoading"]),
  },
  props: {
    source: String,
  },
  data: () => ({
    markers: [],
    coords: {
      lng: 172.64715,
      lat: -43.5781,
    },
    selectedSuveys: [],
    showSurveyList: false,
  }),
  beforeCreate() {
    this.$store.dispatch("loadPastSurveys").then(() => {
      this.init();
    });
  },
  mounted() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.setPosition, this.runError);
    }
  },
  watch: {
    pastSurveys: function () {
      this.init();
    },
  },
  methods: {
    setPosition(position) {
      this.coords.lat = position.coords.latitude;
      this.coords.lng = position.coords.longitude;
      if (this.$refs.gmap) {
        this.$refs.gmap.panToLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      }
    },
    init() {
      this.markers = [];
      this.pastSurveys.forEach((survey) => {
        if (
          survey.startingPoint_lat &&
          survey.startingPoint_lng &&
          !survey.mergedScan
        ) {
          // console.log(survey.startingPoint_lat, survey.startingPoint_lng);
          this.markers.push({
            lat: parseFloat(survey.startingPoint_lat),
            lng: parseFloat(survey.startingPoint_lng),
            data: survey,
          });
        }
      });
    },
    updateCenterPOS(position) {
      this.$refs.gmap.panToLocation(position);
    },
    runError(error) {
      this.$q.notify({
        position: "top-right",
        type: "error",
        message: error.message,
      });
    },
    loadReport(data) {
      this.$emit("viewReport", data);
    },
    showSurveys(data) {
      this.selectedSuveys = [];

      this.pastSurveys.forEach((survey) => {
        if (data.includes(`${survey.id}`)) {
          this.selectedSuveys.push(survey);
        }
      });
      this.showSurveyList = true;
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>

<style>
#reportSlider > .q-slider__track-container {
  background-color: rgba(0, 0, 0, 0) !important;
}
</style>
